import {
  UPLOADER_STATUS_COMPLETED,
  UPLOADER_STATUS_COMPLETING,
  UPLOADER_STATUS_PAUSED,
  type UploaderState,
} from './index';

/**
 * Whether the upload is queued but has never been started, or was cancelled
 * back to that point: queue() and cancel() both leave it paused without chunks.
 */
export const isStagedUpload = (state: UploaderState): boolean =>
  state.status === UPLOADER_STATUS_PAUSED && state.chunks === undefined;

export const getUploadedBytes = (state: UploaderState): number => {
  if (
    state.status === UPLOADER_STATUS_COMPLETING ||
    state.status === UPLOADER_STATUS_COMPLETED
  ) {
    return state.fileInfo.size;
  }
  return (state.chunks ?? []).reduce((sum, chunk) => sum + chunk.uploaded, 0);
};

/** Whether the upload has created anything in Iconik that it owns. */
export const hasCreatedEntities = (state: UploaderState): boolean => {
  const { target, uploadKind } = state;
  if (target.type === 'newAsset' && target.assetId) {
    return true;
  }
  if (target.type === 'newVersion' && target.versionId) {
    return true;
  }
  if (uploadKind.kind === 'proxy') {
    return Boolean(uploadKind.proxyId);
  }
  return Boolean(
    uploadKind.formatId || uploadKind.fileSetId || uploadKind.fileId,
  );
};
